import WorkloadStandart from 'components/_parts/molecules/content/workloadStandart';

function RightContent({ t }: any) {
  return (
    <div className="right_layout">
      <WorkloadStandart t={t} />
    </div>
  );
}

export default RightContent;
